import React from 'react'
export interface RowSelectPopupContentProps {
  dataClassName: string | undefined
  selectedIds: string[]
}

export const RowSelectPopupContent: React.FC<RowSelectPopupContentProps> = ({
  dataClassName,
}) => {
  switch (dataClassName) {
    default:
      return null
  }
}
